import React from 'react';
import { useIntl } from 'react-intl-next';
import { IconButton } from '@atlaskit/button/new';
import Blog24Icon from '@atlaskit/icon-object/glyph/blog/24';
import Page24Icon from '@atlaskit/icon-object/glyph/page/24';
import EditorCloseIcon from '@atlaskit/icon/core/migration/close--editor-close';
import { Box, Flex, Text, xcss } from '@atlaskit/primitives';
import { messages } from './messages';
var SourceOptionWrapperStyles = xcss({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 'space.150',
  boxSizing: 'border-box',
  cursor: 'pointer',
  ':hover': {
    backgroundColor: 'elevation.surface.hovered',
    cursor: 'pointer'
  }
});
var SourceOptionTitleStyles = xcss({
  color: 'color.text',
  font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
var SourceOptionMetadataStyles = xcss({
  display: 'flex',
  color: 'color.text.subtlest',
  font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
var SourceOptionMetatadataSeparatorStyles = xcss({
  marginLeft: 'space.050',
  marginRight: 'space.050'
});
export var SourceOption = function SourceOption(_ref) {
  var source = _ref.source,
    canClear = _ref.canClear,
    onClickSource = _ref.onClickSource,
    onRemoveSource = _ref.onRemoveSource;
  var _useIntl = useIntl(),
    formatDate = _useIntl.formatDate,
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: SourceOptionWrapperStyles,
    onClick: onClickSource
  }, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    gap: "space.150"
  }, source.type === 'blogpost' ?
  /*#__PURE__*/
  // TODO: https://product-fabric.atlassian.net/browse/DSP-20735
  // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
  React.createElement(Blog24Icon, {
    label: ""
  }) :
  /*#__PURE__*/
  // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
  React.createElement(Page24Icon, {
    label: ""
  }), /*#__PURE__*/React.createElement(Flex, {
    direction: "column"
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: SourceOptionTitleStyles
  }, source.title), /*#__PURE__*/React.createElement(Box, {
    xcss: SourceOptionMetadataStyles
  }, /*#__PURE__*/React.createElement(Text, null, source.container), source.lastModified && /*#__PURE__*/React.createElement(Box, {
    xcss: SourceOptionMetatadataSeparatorStyles
  }, "\u2022"), source.lastModified && /*#__PURE__*/React.createElement(Text, null, "".concat(formatMessage(messages.edit_definition_source_option_metadata_updated_text), " ").concat(formatDate(source.lastModified, {
    year: 'numeric',
    month: 'short',
    day: '2-digit'
  })))))), canClear ? /*#__PURE__*/React.createElement(IconButton, {
    testId: "remove-source-".concat(source.id),
    appearance: "subtle",
    onClick: onRemoveSource,
    label: "remove-source-option-button",
    icon: EditorCloseIcon
  }) : /*#__PURE__*/React.createElement("div", null));
};